export default __webpack_public_path__ + "static/media/Professional-Photo.628f2f91.jpg";